import { render } from "./CheckBoxColumn.vue?vue&type=template&id=02f0c523&scoped=true"
import script from "./CheckBoxColumn.vue?vue&type=script&lang=js"
export * from "./CheckBoxColumn.vue?vue&type=script&lang=js"

import "./CheckBoxColumn.vue?vue&type=style&index=0&id=02f0c523&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f0c523"]])

export default __exports__